import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bb_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const naira = (v) => `\u20a6${Number(v || 0).toLocaleString("en-NG")}`;

export const waLink = (number, text) =>
  `https://wa.me/${(number || "2348087798684").replace(/\D/g, "")}?text=${encodeURIComponent(text || "")}`;

export default api;
